import imageFlag from "../staticImages/hellenicEmblem.jpg";

export const parseHtmlStringForPdf = (html, pictureSrc) => {
  let doc = new DOMParser().parseFromString(html, "text/html");
  const images = doc.getElementsByTagName("img");

  for (let image of images) {
    if (image.alt === "imageFlag") {
      const p_hellenicflag = doc.getElementsByTagName("p");

      // let wrapper = doc.createElement("div");
      // console.log(image);
      image.src = `${imageFlag}`;
      image.style.width = `50px`;
      image.style.height = `50px`;
      image.parentNode.insertBefore(p_hellenicflag[0], image);
      p_hellenicflag[0].appendChild(image);
    }
    if (image.alt === "imageApplicant") {
      image.src = `data:image/jpg;base64,${pictureSrc}`;
      image.style.width = `125px`;
      image.style.height = `167px`;
    }
  }
  console.log(doc.documentElement);
  return { data: doc.documentElement.innerHTML };
};

export const parseHtmlStringForEditor = (res, urlImageApplicant, urlFlag) => {
  let doc = new DOMParser().parseFromString(res[0]?.html, "text/html");

  if (doc.getElementById("hellenicFlag")) {
    doc.getElementById("hellenicFlag").src = `${urlFlag}`;
  }

  if (doc.getElementById("imageApplicant")) {
    doc.getElementById("imageApplicant").src = `${urlImageApplicant}`;
  }

  const data = { ...res[0], html: doc.documentElement.innerHTML };
  return [data];
};
